import React, { useCallback, useContext, useEffect, useState } from 'react';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Unstable_Grid2';
import { AuthContext } from '../Contexts/AuthContext';
import { CartContext } from '../Contexts/CartContext';
import { Cli } from './Cli';
import { ProfileConsole } from './ProfileConsole';
import { apiFetch } from '../Helpers/api';

export function TopBar(props) {
  const auth = useContext(AuthContext);
  const cart = useContext(CartContext);
  const [creatingCodebase, setCreatingCodebase] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const [profileMode, setProfileMode] = useState('login');
  const [authError, setAuthError] = useState('');

  const openProfile = useCallback((mode = 'login') => {
    setProfileMode(mode);
    setAuthError('');
    setProfileOpen(true);
  }, []);

  useEffect(() => {
    if (props.profileCommand) {
      openProfile(props.profileCommand.mode || 'login');
    }
  }, [props.profileCommand, openProfile]);

  async function createCodebase() {
    if (!auth.user) {
      openProfile('login');
      return;
    }

    setCreatingCodebase(true);

    try {
      const res = await apiFetch('newcodebase.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({}),
      });
      const json = await res.json();

      if (!res.ok) {
        throw new Error(json.error || 'Could not create codebase.');
      }

      if (json.data?.codebase_id) {
        props.changePage('documentation', json.data.codebase_id);
      }
    } catch (error) {
      setAuthError(error.message);
      setProfileOpen(true);
    } finally {
      setCreatingCodebase(false);
    }
  }

  return (
    <Container className="top-bar" maxWidth={false} style={{ padding: '11px 0px 6px 0px' }}>
      <Container maxWidth={props.appName === 'playtest engine' ? null : 'xl'}>
        <Grid container spacing={2}>
          <Grid xs={12} sm={5} md={4} lg={4}>
            <img className="bug-logo-preload" src="https://www.malwaregame.com/game_assets/ml_logo.png" alt="" aria-hidden="true" />
            <img className="bug-logo-preload" src="https://www.malwaregame.com/game_assets/ml_logo_innocent.png" alt="" aria-hidden="true" />
            <img className="bug-logo" alt="malware" onClick={() => props.changePage('malware')} />
            <h4 style={{ textTransform: 'uppercase' }}>{props.appName}</h4>
          </Grid>
          <Grid xs={12} sm={3} md={4} lg={4}>
            <Cli changePage={props.changePage} openCart={props.openCart} openProfile={openProfile} />
          </Grid>
          <Grid className="top-bar-right" xs={12} sm={4} md={4} lg={4}>
            {props.appName === 'playtest engine' && (
              <>
                {/* <button className="cli-button" onClick={() => props.changePage('rules')}>game rules</button> */}
                <button onClick={() => props.resetPlaytest()} className="cli-button">restart playtest</button>
              </>
            )}
            { (props.appName === 'documentation' && auth.user) && (
              <button className="cli-button" onClick={createCodebase} disabled={creatingCodebase}>
                {creatingCodebase ? 'creating codebase...' : 'develop new codebase'}
              </button>
            )}
            <button className="cli-button-white profile-button" onClick={() => openProfile(auth.user ? 'profile' : 'login')}>
              {auth.user ? (auth.user.display_name || auth.user.username) : 'profile'}
            </button>
            <button className="cli-button cart-top-button" onClick={props.openCart}>
              cart [{cart.itemCount}]
            </button>
          </Grid>
        </Grid>
      </Container>
      {authError && profileOpen && <div className="auth-error">{authError}</div>}
      <ProfileConsole
        open={profileOpen}
        mode={profileMode}
        resetToken={props.resetToken}
        onClose={() => setProfileOpen(false)}
        changePage={props.changePage}
      />
    </Container>
  );
}
